import {
  fetchGetPaymentHistoryFailure,
  fetchGetPaymentHistorySuccess,
} from "./reducer";
import { PAYMENT_HISTORY_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getPaymentHistory =
  (customerId, setLoading, lastCompletedAt, setHasNextPage) => async (dispatch) => {
    try {
      setLoading(true);
      const cursor = lastCompletedAt ? lastCompletedAt : "";
      const response = await determineBaseUrlAndPerformApiCall(
        `${PAYMENT_HISTORY_API}/${customerId}?limit=10&lastCompletedAt=${cursor}`,
        "GET"
      );
      if (!response.error) {
        dispatch(fetchGetPaymentHistorySuccess(response));
      } else {
        dispatch(fetchGetPaymentHistoryFailure(response.error.message));
        setHasNextPage(false);
      }
    } catch (error) {
      dispatch(fetchGetPaymentHistoryFailure("Something went wrong"));
      setHasNextPage(false);
    } finally {
      setLoading(false);
    }
  };